import { render, staticRenderFns } from "./material-file.vue?vue&type=template&id=11030ea0&scoped=true&"
import script from "./material-file.vue?vue&type=script&lang=js&"
export * from "./material-file.vue?vue&type=script&lang=js&"
import style0 from "./material-file.vue?vue&type=style&index=0&id=11030ea0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11030ea0",
  null
  
)

export default component.exports